import './team-grid.scss'

const selectors = {
  member: '[data-team-member]',
  memberPopup: '[data-team-member-popup]',
  memberTrigger: '[data-team-member-trigger]',

  active: 'active',
}

const initTeamGrid = () => {
  const members = document.querySelectorAll(selectors.member)

  members.forEach((member) => {
    const popup = member.querySelector(selectors.memberPopup)
    const triggers = member.querySelectorAll(selectors.memberTrigger)

    triggers.forEach((trigger) => trigger.addEventListener('click', () => popup.classList.toggle(selectors.active)))
  })
}

document.addEventListener('DOMContentLoaded', async function () {
  initTeamGrid()
})
